export default "__VITE_ASSET__DhyMeOPR__"